<template>
  <div class="mb-6">
    <!-- Label -->
    <label :for="id" class="block w-full mb-1 text-black">
      {{ label }}
      <span v-if="required" class="text-nucleus-error font-bold"> * </span>
    </label>

    <div class="relative">
      <!-- Input -->
      <textarea
        :id="id"
        class="block w-full border border-nucleus-darkestBlue rounded p-2 bg-nucleus-lightestBlue color-nucleus-darkestBlue focus:outline-none focus:ring-2 focus:ring-nucleus-primaryBlue focus:border-transparent"
        :class="{
          'border-nucleus-error focus:ring-nucleus-error': error,
        }"
        :value="value"
        :placeholder="placeholder"
        :maxlength="maxLength"
        @input="updateValue"
        @focus="isFocused = true"
        @blur="isFocused = false"
      ></textarea>
    </div>

    <!-- Error Message -->
    <div v-if="error" class="text-nucleus-error absolute text-xs">
      {{ error }}
    </div>
  </div>

  <!-- Hint -->
  <!-- <div
      v-else-if="hint"
      class="base-input--hint"
      :class="{ 'text-blue-500': isFocused, 'text-gray-500': !isFocused }"
    >
      {{ hint }}
    </div> -->
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["update:value", "updateInputType"],
  props: {
    label: String,
    icon: String,
    placeholder: String,
    value: String,
    error: String,
    required: Boolean,
    id: String,
    maxLength: Number,
  },
  data() {
    return {
      isFocused: false,
    };
  },
  methods: {
    // Update Model Value
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateValue(event: any) {
      this.$emit("update:value", event.target.value);
    },
  },
})
export default class Input extends Vue {}
</script>
